export default {
  namespaced: true,
  state: {
    user: null,
    slug: "",
    communityType: "",
    communityId: null,
    invitedSlug:"",
    paymentMethodId: null,
    isPremium: null,
    ssoOrgCode: null,
    isCommunityGroup: false,
    // From GET /employees/corporate-url: drives the subscription banner.
    subscription: null,
  },
  mutations: {
    setUserInformation(state, data) {
      state.userData = data
    },
    setInvitedSlug(state, slug) {
      state.invitedSlug = slug
    },
    setSlug(state, slug) {
      state.slug = slug
    },
    setCommunityId(state, id) {
      state.communityId = id
    },
    setCommunityType(state, type) {
      state.communityType = type
    },
    setPaymentMethodId(state, id) {
      state.paymentMethodId = id
    },
    setIsPremium(state, isPremium) {
      state.isPremium = isPremium
    },
    ssoOrgCode(state, code) {
      state.ssoOrgCode = code
    },
    setIsCommunityGroup(state, value) {
      state.isCommunityGroup = value
    },
    setSubscription(state, subscription) {
      state.subscription = subscription || null
    },
  },
  getters: {
    loggedInUserInformation: state => {
      const { userData } = state
      return userData
    },
  },
  actions: {},
}
